module.exports = __webpack_public_path__ + "img/pg5-fig1-table.7519ee57.png";